<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIsoIcTetkik from "@/models/StrIsoIcTetkik";
export default {
  mixins: [Api, Sabit, StrIsoIcTetkik],
  props: ["Tetkikid", "OPersonelid"],
  data() {
    return {
      TableData: [],
      No: null,
      Soru: null
    };
  },
  components: {
    Loader
  },
  watch: {
    Tetkikid() {
      this.TableGet();
    },
  },
  methods: {
    TableGet() {
      if (this.Tetkikid) {
        var Page = {
          PageNumber: "1",
          PageSize: "9999",
          PageDataSize: "1",
        }
        this.ActionsFilterGet({ Service: "StrIsoIcTetkikCevap/GetCevapEkleme", Page: Page, Filter: "&Tetkikid=" + this.Tetkikid + "&Cevaplayanid=" + this.OPersonelid }).then((res) => {
          this.TableData = res.Data;
        });
      }
    },
    Get() { this.TableGet() },
    onSubmit() { 
        this.AllUpdate("StrIsoIcTetkikCevap/PutList", this.TableData)
 
    }, 

  },
};
</script>
<template>
  <Loader>
    <b-modal id="StrIsoIcTetkikCevap" size="lg" title="İç Tetkik Soru Cevaplama" title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">
        <div class="row"> 
 
          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th>Soru No</th>
                  <th>Soru</th>
                  <th>Uygun</th>
                  <th>Uygun Değil</th>
                  <th>Birime Uygun Değil</th>
                  <th>Açıklama</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Data in TableData" :key="Data.Id">
                  <th scope="row">{{ Data.No }}</th>
                  <td>{{ Data.Soru }}</td> 
                  <td>
                    <div class="action-is w-100 d-flex justify-content-center align-items-center">
                      <i class="fas fa-check" tooltip="Kapanış" @click="Data.Cevap = 1" v-if="Data.Cevap == null"></i>
                      <i class="fas fa-times" @click="Data.Cevap = null" v-if="Data.Cevap == 1"></i>  
                    </div> 
                  </td>
                  <td>
                    <div class="action-is w-100 d-flex justify-content-center align-items-center">
                      <i class="fas fa-check" tooltip="Kapanış" @click="Data.Cevap = 2" v-if="Data.Cevap == null"></i>
                      <i class="fas fa-times" @click="Data.Cevap = null" v-if="Data.Cevap == 2"></i>  
                    </div> 
                  </td>
                  <td>
                    <div class="action-is w-100 d-flex justify-content-center align-items-center">
                      <i class="fas fa-check" tooltip="Kapanış" @click="Data.Cevap = 3" v-if="Data.Cevap == null"></i>
                      <i class="fas fa-times" @click="Data.Cevap = null" v-if="Data.Cevap == 3"></i>  
                    </div> 
                  </td>
                  <td>
                    <b-form-input   v-model="Data.Aciklama" class="form-control" ></b-form-input> 
                  </td>
                </tr>
              </tbody>
            </table>
          </div> 

          
        </div>
        <button class="btn btn-primary " type="submit">
          Kaydet
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
